import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { ConfigService } from './config.service';
import { User } from '../models/users';

@Injectable({
  providedIn: 'root'
})
export class RestService {



 constructor(public http: HttpClient, public configProvider: ConfigService) { }

 login(email: string, password: string) {
  const httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, PATCH, DELETE',
      // tslint:disable-next-line:max-line-length
      'Access-Control-Allow-Headers': 'Access-Control-Allow-Headers, Origin,Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers'
    })
  };
  let data = [{ email: email, password: password }];

 // console.log(JSON.stringify(data));

  return new Promise((resolve, reject) => {
    this.http.post(this.configProvider.getURLServe('Login'), JSON.stringify(data))
      .subscribe((result: any) => {
       resolve(result);
      },
        (error) => {
          console.log(JSON.stringify(error));
         if(error.status == 500){
    
         }
         else{
           
         }
          reject(error);
        });
  });
}

 register(obj: User) {
  return new Promise((resolve, reject) => {

    this.http.post(this.configProvider.getURLServe('Register'), JSON.stringify(obj))
      .subscribe((result: any) => {
        //alert("cds");
        //alert(JSON.stringify(result));
        resolve(result);
      },
        (error) => {
          //alert(JSON.stringify(error));
          //console.log(JSON.stringify(error));
          reject(error);
        });
  });
}

 post(obj: Object, route: string, method: string, admin: boolean = false) {
  const httpOptions = {
    headers: new HttpHeaders({
      'Content-Type':  'application/json',
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, PATCH, DELETE',
      'Access-Control-Allow-Headers':
      // tslint:disable-next-line:max-line-length
      'Access-Control-Allow-Headers, Origin,Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers'
    })
  };
  return new Promise((resolve, reject) => {
    this.http.post(this.configProvider.getURLServe(route, admin) + '/' + method, JSON.stringify(obj))
      .subscribe((result: any) => {
        //alert(JSON.stringify(result));
        resolve(result);
      },
        (error) => {
    
          reject(error);
        });
  });
}
}
